export default __webpack_public_path__ + "static/media/eb-ultra-wht-4.d86789b2.png";